import VehicleSelectCardHomeView from "@/src/components/atoms/VehicleSelectCard/VehicleSelectCardHomeView";
import VehicleSelectCardWizardView from "@/src/components/atoms/VehicleSelectCard/VehicleSelectCardWizardView";

import { VehicleType } from "@/src/types/types";

export type VehicleSelectCardDisplayMode = "homePageView" | "auctionWizardView";

interface VehicleSelectCardProps {
  selectedVehicleType: VehicleType;
  onVehicleTypeChange: (value: VehicleType) => void;
  vehicleLabel: string;
  vehicleType: VehicleType;
  displayMode: VehicleSelectCardDisplayMode;
}

const VehicleSelectCard = (props: VehicleSelectCardProps) => {
  const { displayMode, ...rest } = props;

  if (displayMode === "homePageView") {
    return <VehicleSelectCardHomeView {...rest} />;
  }

  return <VehicleSelectCardWizardView {...rest} />;
};

export default VehicleSelectCard;
